import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import constants from '../../../constants'
import classnames from 'classnames'
import Icon from 'components/common/Icon'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'
import Toggle from 'components/common/Toggle'
import { checkboxIcon } from '../../../utils'

@inject('uiStore', 'selectionStore')
@observer
class UserShapefileShapeListItem extends Component {
  constructor (props) {
    super(props)
    this.itemRef = React.createRef()
  }

  componentDidUpdate (prevProps) {
    // scroll newly-selected items into view
    if (
      this.props.selected === true &&
      prevProps.selected === false
    ) {
      if (this.itemRef.current) {
        scrollIntoViewIfNeeded(this.itemRef.current, { centerIfNeeded: true })
      }
    }
  }

  render () {
    const {
      uiStore,
      shape,
      userShapefileList
    } = this.props

    const handleShapeClick = async () => {
      shape.toggleSelected()
      if (!shape.geoJSON) {
        uiStore.processing = true
        await shape.loadGeometry()

        if (
          userShapefileList.selectedLevel.totalPoints > constants.MAX_PREVIEW_POINTS
        ) {
          uiStore.setBoundsToItem(shape)
        }
        uiStore.processing = false
      } else {
        if (uiStore.zoomWhilePreviewing && shape.selected) {
          uiStore.setBoundsToItem(shape)
        }
      }
    }

    return (
      <li
        ref={this.itemRef}
        className={classnames('shapefile-item', {
          nonexpandable: true,
          selected: shape.selected
        })}
        id={`shape-shapefile-${shape.id}`}
      >
        <nav className='shapefile-nav shapefile-item'>
          <span className='shapefile-nav__item name' onClick={() => handleShapeClick()}>
            <Icon id='polygon' />
            <span>{shape.name}</span>
          </span>
          <Toggle
            icon={checkboxIcon(shape.selected)}
            enabled={shape.selected}
            onClick={() => handleShapeClick()}
          />
        </nav>
      </li>
    )
  }
}

export default UserShapefileShapeListItem
